
import { observer } from 'mobx-react-lite'
// evertel

import {
    Icon,
    FloatingMenu, MenuItem
} from '@evertel/web/ui'
import { HTMLAttributes } from 'react'
import { useService } from '@evertel/di'
import { CurrentUserController } from '@evertel/blue-user'
import { useInvite } from '@evertel/web/invites'
import { useCreateRoom, useJoinRoom } from '@evertel/web/room'
import { useCreateThread } from '@evertel/web/thread'

interface HeaderButtonAddProps extends HTMLAttributes<HTMLButtonElement> {
    none?: any
}

const HeaderButtonAdd: React.FC<HeaderButtonAddProps> = observer(({
    ...otherProps
}) => {

    const currentUserController = useService(CurrentUserController, [])
    const { openInvite } = useInvite()
    const { openCreateRoom } = useCreateRoom()
    const { openCreateThread } = useCreateThread()
    const { openJoinRoom } = useJoinRoom()

    const openInviteModal = () => {
        if (currentUserController.canManage) {
            openInvite('department')
        } else {
            openInvite('contact')
        }
    }

    return (
        <FloatingMenu
            id="header-button-actions-menu"
            label="Actions Menu"
            title="Actions Menu"
            aria-label="Actions Menu"
            renderLabel={() => (
                <Icon
                    name="plus-circle"
                    size={16}
                />
            )}
            {...otherProps}
        >
            <MenuItem
                label="Join Room"
                icon={{ name: 'circle-plus' }}
                onClick={() => openJoinRoom()}
            />
            {currentUserController.canManage && (
                <MenuItem
                    label="Create Room"
                    icon={{ name: 'hashtag' }}
                    onClick={() => openCreateRoom()}
                />
            )}
            <MenuItem
                label="Send Direct Message"
                icon={{ name: 'comment-alt-lines' }}
                onClick={() => openCreateThread()}
            />
            {currentUserController.canManage && (
                <MenuItem
                    label="Invite People"
                    icon={{ name: 'users' }}
                    onClick={() => openInviteModal()}
                />
            )}
        </FloatingMenu>
    )
})

export { HeaderButtonAdd }
